import React from 'react'
import PropTypes from 'prop-types'
import {
  TableCell,
  TableHead,
} from '../../../../../components/common/ResponsiveTable'
import { useTrans } from '../../../../../services/i18n'
import { CheckBox } from '../../../../../components/common/Inputs'

export default function Head({
  isAllChecked,
  isSomeChecked,
  onSelectAll,
}) {
  const { trans } = useTrans()

  return (
    <TableHead>
      <TableCell>
        <CheckBox
          dense
          color="secondary"
          checked={isAllChecked}
          indeterminate={isSomeChecked && !isAllChecked}
          onChange={onSelectAll}
        />
      </TableCell>
      <TableCell>{trans('name')}</TableCell>
      <TableCell>{trans('owner')}</TableCell>
      <TableCell>{trans('date-created')}</TableCell>
      <TableCell>{trans('scope')}</TableCell>
      <TableCell>{trans('Count')}</TableCell>
      <TableCell>{trans('emailing')}</TableCell>
      <TableCell width={1} align="right" />
      <TableCell width={1} align="right" />
    </TableHead>
  )
}

Head.propTypes = {
  isAllChecked: PropTypes.bool,
  isSomeChecked: PropTypes.bool,
  onSelectAll: PropTypes.func,
}
